/* eslint semi:0 */
import { memoizeFirstCall, } from '../../jsCore/utils/fn'
import { namespacedConsts, } from '../../jsCore/utils/object'
import { getApiEndpoints, } from '../../jsCore/application/api'
import {
  getNamespacedFetchActionTypes, FETCH_REQUEST_ACTION_TYPE,
  FETCH_REQUEST_STARTING_ACTION_TYPE,
} from '../../jsCore/application/sagas/fetchSaga'


export const API_ENDPOINT_NAME = 'TV_SCHEDULE'

export const TV_SCHEDULE_ACTION_TYPES = {
  ...namespacedConsts({
    CHANGE_TV_SCHEDULE_DATE: true,
    CHANGE_SELECTED_CHANNEL_NAME: true,
    LOADING_DATA: true,
  }),
  ...memoizeFirstCall(
    'TV_SCHEDULE_ACTION_TYPES',
    getNamespacedFetchActionTypes,
    API_ENDPOINT_NAME
  ).TV_SCHEDULE_ACTION_TYPES,
}

const {
  CHANGE_SELECTED_CHANNEL_NAME, 
  CHANGE_TV_SCHEDULE_DATE,
  LOADING_DATA,
} = TV_SCHEDULE_ACTION_TYPES


export function fetchData(dataTransformer, date){
  const { TV_SCHEDULE_ACTION_TYPES: { url, endpointName, }, } =
    memoizeFirstCall('TV_SCHEDULE_ACTION_TYPES', getApiEndpoints, API_ENDPOINT_NAME)
  const urlWithParams = `${ url }/${ date }.json`

  return (dispatch, getState) => dispatch({
    type: FETCH_REQUEST_ACTION_TYPE,
    payload: {
      url: urlWithParams,
      endpointName,
      dataTransformer,
      additionalState: {
        IS_INITIALIZED: true,
        IS_LOADING: false,
      },
    },
  })
}

export function setLoading() {
  return (dispatch, getState) => dispatch({
    type: LOADING_DATA,
    state: {
      IS_LOADING: true,
    }
  })
}

export function changeSelectedChannelName(selectedChannelName){
  return (dispatch, getState) => dispatch({
    type: CHANGE_SELECTED_CHANNEL_NAME,
    state: {
      currentChannelName: selectedChannelName,
    },
  })
}

export function changeTvScheduleDate(newDate){
  return (dispatch, getState) => dispatch({
    type: CHANGE_TV_SCHEDULE_DATE,
    state: {
      scheduleDate: newDate,
    },
  })
}

export const tvScheduleActions = {
  fetchData, changeSelectedChannelName, changeTvScheduleDate,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/tv_channel_selection/tvScheduleActions.js